import {pick, omitBy, isUndefined} from 'lodash'

export function extractValidProperties<T extends object, K extends keyof T>(
  params: T,
  keys: K[]
): Partial<T> {
  return {...omitBy(pick(params, keys), isUndefined)} as Partial<T>
}
